import { Card, CardBody, CardExpandToggler } from '../../../components/card/card.jsx';
// import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';
import Bar from '../../dashboard/Bar.jsx';
import { useTranslation } from 'react-i18next';

const EmployeeByNationality = () => {
  const { t, i18n } = useTranslation();
  const Employees = [
    { id: 1, name: 'محمد', nationality: i18n.language === 'en' ? 'Saudi' : 'سعودي' },
    { id: 2, name: 'أحمد', nationality: i18n.language === 'en' ? 'Egyptian' : 'مصري' },
    { id: 3, name: 'سارة', nationality: i18n.language === 'en' ? 'Indian' : 'هندي' },
    { id: 4, name: 'ليلى', nationality: i18n.language === 'en' ? 'Saudi' : 'سعودي' },
    { id: 5, name: 'علي', nationality: i18n.language === 'en' ? 'Egyptian' : 'مصري' },
    { id: 6, name: 'خالد', nationality:  i18n.language === 'en' ? 'Indian' : 'هندي' },
    { id: 7, name: 'فاطمة', nationality: i18n.language === 'en' ? 'Saudi' : 'سعودي' },
    { id: 8, name: 'يوسف', nationality: i18n.language === 'en' ? 'Yemeni' : 'يمني' },
    { id: 9, name: 'عائشة', nationality: i18n.language === 'en' ? 'Syrian' : 'سوري' },
  ];

  // حساب توزيع الموظفين حسب الجنسية
  function countEmployeesByNationality(employees) {
    const nationalityCount = {};

    employees?.forEach((employee) => {
      const nationality = employee.nationality;
      if (nationalityCount[nationality]) {
        nationalityCount[nationality].count++;
      } else {
        nationalityCount[nationality] = {
          name: nationality,
          count: 1,
        };
      }
    });

    // تحويل النتيجة إلى مصفوفة من الكائنات
    const result = Object.values(nationalityCount);

    return result;
  }

  const [data, setData] = useState([]);

  useEffect(() => {
    const generatedData = countEmployeesByNationality(Employees);
    setData(generatedData);
  }, []);

  return (
    <div>
      <Card className="mb-3" style={{ height: '100%' }}>
        <CardBody className="">
          <div className="d-flex fw-bold small mb-3">
            <span className="flex-grow-1">{t('EmployeesByNationality')}</span>
            <CardExpandToggler />
          </div>
          <Bar
            categories={data?.map((item) => item?.name || 'غير محدد')}
            series={[
              {
                name: t('employee'),
                data: data?.map((item) => item?.count || 0),
              },
            ]}
            height={400}
            // isStacked
          />
        </CardBody>
      </Card>
    </div>
  );
};

export default EmployeeByNationality;
